import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertMessage } from '@app/core/models/alert/alert-message';
import { AlertMessageType } from '@app/core/models/alert/alert-message-type';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { isTrue, safeProp } from '@util';
import * as R from 'ramda';
import { timer } from 'rxjs';

const getAutoCloseTime = R.cond([
  [R.equals(AlertMessageType.Info), R.always(10000)],
  [R.T, R.always(5000)]
]);

@Component({
  selector: 'pcs-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertMessageComponent implements OnInit {

  @Input() alert: AlertMessage;
  @Input() autoClose = true;

  @Output() removed = new EventEmitter<AlertMessage>();

  constructor(private translate: PcsTranslateService) {}

  ngOnInit(): void {
    if (this.autoClose) {
      timer(getAutoCloseTime(this.type)).subscribe(() => {
        this.onClose(this.alert);
      });
    }
  }

  getMessage() {
    return this.translate.translate(this.alert.message, this.getMessageParams());
  }

  getMessageParams() {
    return isTrue(this.alert.translateParams) ? R.map(param => this.translate.translate(param), this.alert.params) : this.alert.params;
  }

  get dismissible() {
    return safeProp('dismissible', this.alert);
  }

  get type() {
    return safeProp('type', this.alert);
  }

  onClose(alert: AlertMessage) {
    this.removed.emit(alert);
  }

}

